import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import { FormattedMessage } from 'react-intl';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import Dialog from '@afosto/app-components-react/Dialog';
import translations from './translations';

const ForceCancelOrderDialog = ({ isOpen, onClose, onContinue, warnings }) => {
  const intl = useIntl();

  const getTranslatedWarningMessage = message => {
    if (message.indexOf('transports might shipped') > -1) {
      return intl.formatMessage(translations.warnings.transportsShipped);
    }

    return message;
  };

  return (
    <Dialog open={isOpen}>
      <DialogTitle>
        <FormattedMessage {...translations.title} />
      </DialogTitle>
      <DialogContent>
        {warnings?.length > 0 && (
          <>
            <Typography variant="body2">
              <FormattedMessage {...translations.warningDescription} />
            </Typography>
            <ul style={{ paddingLeft: 20 }}>
              {warnings.map(message => (
                <li key={btoa(message)}>
                  <Typography variant="body2">{getTranslatedWarningMessage(message)}</Typography>
                </li>
              ))}
            </ul>
          </>
        )}
        {warnings?.length === 0 && (
          <Typography variant="body2">
            <FormattedMessage {...translations.description} />
          </Typography>
        )}
      </DialogContent>
      <DialogActions style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Button variant="outlined" onClick={onClose}>
          <FormattedMessage {...translations.actions.cancel} />
        </Button>
        <Button color="primary" variant="contained" onClick={onContinue}>
          <FormattedMessage {...translations.actions.continue} />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ForceCancelOrderDialog.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onContinue: PropTypes.func,
  warnings: PropTypes.array,
};

ForceCancelOrderDialog.defaultProps = {
  isOpen: false,
  onClose: undefined,
  onContinue: undefined,
  warnings: [],
};

export default ForceCancelOrderDialog;
